export default __webpack_public_path__ + "images/EY.ef692cf.png";